import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  formHeader: {
    display: 'flex',
    flexDirection: 'row'
  },
  fieldRow: {
    display: 'block',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  },
  field: {
    margin: theme.spacing(),
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      whiteSpace: 'normal'
    }
  },
  menuItem: {
    overflow: 'auto',
    whiteSpace: 'normal !important',
    minWidth: '100%',
    maxWidth: 'fit-content'
  },
  buttons: {
    margin: theme.spacing(1)
  },
  actionsContainer: {
    borderTop: 'solid 1px',
    borderTopColor: theme.palette.grey[400],
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(),
    '& button': {
      marginRight: theme.spacing()
    }
  }
}))

export default useStyles
